<template>
  <a-modal
    :visible="visible"
    :confirm-loading="loading"
    :mask-closable="false"
    @ok="onOk"
    @cancel="$emit('update:visible', false)"
  >
    <div>
      <a-form
        ref="decisionFormRef"
        :model="decisionForm"
        :rules="rules"
        layout="vertical"
      >
        <a-form-item
          name="decisionDescription"
          :label="$t('pages_receipt_075')"
          :required="true"
        >
          <a-select
            v-model:value="decisionForm.decisionDescription"
            @change="loadRefundIndicators"
          >
            <a-select-option
              v-for="item in decisions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          name="refundIndicator"
          :label="$t('pages_receipt_076')"
          :required="true"
        >
          <a-select
            v-model:value="decisionForm.refundIndicator"
          >
            <a-select-option
              v-for="item in refunds"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div v-if="errorTip" class="error-tip">{{ errorTip }}</div>
  </a-modal>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { _order } from '@/api'
import i18n from '@/locale'
export default {
  name: 'EthocaDecision',
  props: {
    visible: {
      type: Boolean,
      default: () => { return false }
    }
  },
  setup(props, ctx) {
    const state = reactive({
      record: {},
      rules: {
        decisionDescription: [
          { required: true, message: i18n.global.t('pages_receipt_085'), trigger: 'blur' }
        ],
        refundIndicator: [
          { required: true, message: i18n.global.t('pages_receipt_086'), trigger: 'blur' }
        ]
      },
      loading: false,
      errorTip: '',
      decisionForm: {
        decisionDescription: '',
        refundIndicator: ''
      },
      decisionFormRef: null,
      decisions: [
        { label: i18n.global.t('pages_receipt_077'), value: 'resolved' },
        { label: i18n.global.t('pages_receipt_078'), value: 'unresolved_dispute' },
        { label: i18n.global.t('pages_receipt_079'), value: 'previously_refunded' },
        { label: i18n.global.t('pages_receipt_080'), value: 'notfound' },
        { label: i18n.global.t('pages_receipt_081'), value: 'other' }
      ],
      refunds: [
        { label: i18n.global.t('pages_receipt_082'), value: 'refunded' },
        { label: i18n.global.t('pages_receipt_083'), value: 'not_refunded' },
        { label: i18n.global.t('pages_receipt_084'), value: 'not_settled' }
      ]
    })

    const loadRefundIndicators = (value) => {
      console.log('value', value)
      switch (value) {
        case 'resolved':
          state.refunds = [
            { label: i18n.global.t('pages_receipt_082'), value: 'refunded' },
            { label: i18n.global.t('pages_receipt_083'), value: 'not_refunded' },
            { label: i18n.global.t('pages_receipt_084'), value: 'not_settled' }
          ]
          break
        case 'unresolved_dispute':
          state.refunds = [
            { label: i18n.global.t('pages_receipt_083'), value: 'not_refunded' }
          ]
          break
        case 'previously_refunded':
          state.refunds = [
            { label: i18n.global.t('pages_receipt_082'), value: 'refunded' }
          ]
          break
        case 'notfound':
          state.refunds = [
            { label: i18n.global.t('pages_receipt_083'), value: 'not_refunded' }
          ]
          break
        case 'other':
          state.refunds = [
            { label: i18n.global.t('pages_receipt_082'), value: 'refunded' },
            { label: i18n.global.t('pages_receipt_083'), value: 'not_refunded' },
            { label: i18n.global.t('pages_receipt_084'), value: 'not_settled' }
          ]
          break
      }
    }

    const updateRecord = (record) => {
      state.decisionForm = {
        decisionDescription: '',
        refundIndicator: ''
      }
      state.record = record
      state.errorTip = ''
    }

    const onOk = () => {
      // ctx.emit('update:visible', false)
      // validate form
      const form = state.decisionFormRef
      form.validate().then(() => {
        state.loading = true
        _order.ethocaDisputeDecision({
          id: state.record.id,
          decisionDescription: state.decisionForm.decisionDescription,
          refundIndicator: state.decisionForm.refundIndicator
        }).then(res => {
          if (res.data.succ) {
            ctx.emit('update:visible', false)
            ctx.emit('update:records')
          } else {
            // prompt error
            state.errorTip = 'System Error'
          }
        }).finally(() => {
          state.loading = false
        })
      }).catch(error => {
        console.error('Validation failed:', error)
      })
    }

    return {
      onOk,
      loadRefundIndicators,
      updateRecord,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="less" scoped>
.error-tip {
  margin-top: 8px;
  color: @error-color;
}
</style>
